export default __webpack_public_path__ + "static/media/plus-black.1542b5ab.svg";